import { createStore, applyMiddleware , compose } from 'redux';
import { config } from 'hub-redux-auth';
import CleverTapHandler from './services/cleverTap';
import reducer from './reducers';
import cleverTapWare from './middlewares/cleverTapWare';
import AccountCreated from './components/AccountCreated';

CleverTapHandler.initialize();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducer,
  composeEnhancers(
    applyMiddleware(cleverTapWare)
  )
);

const clientId = document.getElementById('hub-client-id').dataset.client_id;
const hubHost = document.getElementById('hub-host').dataset.host;

config.set('grantType', 'client_credentials');
config.set('clientId', clientId);
config.set('tokenScope', 'find_or_create send_sign_in_otp verify_sign_in_otp');
config.set('loginScope', 'send_verification_otp user_profile verify_verification_otp update_user_profile update_profile_restricted');
config.set('loginRedirectUrl', '/manage_account');
config.set('createUserUrl', '/api/v1/user/create_user');
config.set('hubHost', hubHost);
config.set('cleverTap', CleverTapHandler);
config.set('tncURL', 'https://reseller.payu.in/raf_tnc');
config.set('accountCreatedComponent', AccountCreated);
config.set('skip_password_expired_screen', true);
config.set('referModal', true);
config.set('searchKeys', ['invite_token']);

/* eslint-enable */
export default store;
